module.exports = __webpack_public_path__ + "static/media/guardian.1b44379b.png";